<!--  -->
<template>
  <div>
    <div v-if="creditFailureList.length !== 0" class="MyLoadRight" ref="right">
      <my-load-list v-if="activeIndex === 1" :list="creditFailureList"></my-load-list>
      <my-aggs-list v-else :list="creditFailureList"></my-aggs-list>
    </div>
    <div class="nodata" v-if="creditFailureList.length === 0">
      <img src="@/assets/images/nodata.png" alt="" />
      <p>
        这里什么都没有，快<span style="color:#F56446;" @click="goTofinancing"
          >去填写融资申请</span
        >吧！
      </p>
    </div>
  </div>
</template>

<script>
import MyLoadList from './MyLoadList.vue';
import MyAggsList from './MyAggsList.vue';

export default {
  name: 'MyLoadRight',
  components: {
    MyLoadList,
    MyAggsList,
  },
  props: ['creditFailureList','activeIndex'],
  mounted() {
    // this.$refs.right.style.height = `${document.documentElement.clientHeight-125}px`
  },
  data() {
    return {};
  },
  methods: {
    goTofinancing() {
      this.$router.push('/supermarket/v2/');
    },
  },
};

</script>
<style scoped>

.nodata {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 14px;
  padding: 20px 0;
  color: #9ea7b4;
}
.nodata img{
  width: 100%;
}
.MyLoadRight { height: auto !important; }

</style>
